import Command from '../general/Command';
import Plugin from '../general/Plugin';

import { setVideoLeadershipListenersHTML5 } from './video-leadership';

const MT_PLAYBACK_STATUS = 'mirror--playback_status';

class VideoPlayerControls extends Plugin {
  constructor(manager, browser) {
	  super();
	  this.playing = false;
	  this.manager = manager;
	  this.recievedPlayCommandAt = null;
    this.browser = browser;

    // NOTE: browser.iphone means its ipad or iphone
    // Safari desktop does/doesnt work without doing this.
    this.isSafari = this.browser.browser === 'safari' && this.browser.version >= 605 && this.browser.iphone;
  }

  getCommands() {
    let video = $('#remoteVideo');
    let backupStream;
    let latestVideo;
    const loadVideoClip = new Command('load_video_clip', (data) => {
      video.removeAttr('autoplay');
      if (backupStream != null) {
        console.error('backup stream was not null btw', backupStream, video[0].srcObject);
      }
      backupStream = video[0].srcObject;
      video[0].srcObject = null;
      video[0].muted = this.isSafari;
      video[0].src = data.args.url;
      video[0].oncanplaythrough = (e) => {
        if (data.args.url === latestVideo) return;
        this.manager.sendMessage({ status: 'ready', role: manager.role, from: manager.publicKey}, MT_PLAYBACK_STATUS, data.from);
        latestVideo = data.args.url;
      };
      video[0].onended = (e) => {
        this.manager.sendMessage({ status: 'ended', role: manager.role, from: manager.publicKey}, MT_PLAYBACK_STATUS, data.from);
      };
      // disable the event temporarily
      window.cancelShowViewportPlaceholder = true;
      // hide the viewport placeholder
      $('#viewportPlaceholderText').addClass('hidden');

      // Show text "Tap to unmute" for safari
      if (this.isSafari) {
        let tapToUnmuteButton = document.querySelector('#tapToUnmuteButton');
        if (tapToUnmuteButton) {
          tapToUnmuteButton.classList.remove('hidden');
          tapToUnmuteButton.onclick = () => {
            video[0].muted = false;
            tapToUnmuteButton.classList.add('hidden');
          };
        }
      }
      // Show text "Review Mode"
      $('#playbackOn').removeClass('hidden');
      setVideoLeadershipListenersHTML5(video);
    });
    const setTimeVideoClip = new Command('set_time_video_clip', (data) => {
      if (video[0] == null) video = $('#videoTakePlayback_controller');
      video[0].currentTime = data.args.currentTime;
    });
    const playVideoClip = new Command('play_video_clip', (data) => {
      if (video[0] == null) video = $('#videoTakePlayback_controller');
		  this.requestPlay(video);
      this.playing = true;
      this.manager.sendMessage({ status: 'playing', role: manager.role, from: manager.publicKey}, MT_PLAYBACK_STATUS, data.from);
    });
    const pauseVideoClip = new Command('pause_video_clip', (data) => {
      if (video[0] == null) video = $('#videoTakePlayback_controller');
      video[0].pause();
      this.manager.sendMessage({ status: 'paused', role: manager.role, from: manager.publicKey}, MT_PLAYBACK_STATUS, data.from);
    });
    const stopVideoClip = new Command('stop_video_clip', (data) => {
      if (video[0] == null) video = $('#videoTakePlayback_controller');
      video.attr('autoplay', 'autoplay');
      video[0].src = '';
      video[0].srcObject = backupStream;
      if (backupStream == null) $('#viewportPlaceholderText').removeClass('hidden');
      $('#playbackOn').addClass('hidden');
      $('#tapToUnmuteButton').addClass('hidden');
      backupStream = null;
      video[0].play();
    });
    return [loadVideoClip, setTimeVideoClip, playVideoClip, pauseVideoClip, stopVideoClip];
  }

  // In Safari this shows a banner to play the file, if its not in Safari it just plays the video
  //  because files cannot be played without a user action
  requestPlay(videoEl) {
    // save when the play command was recieved
    //
    videoEl[0].play().then((msg) => { console.log('Play requested', msg); });
    return;
    if (this.isSafari) {
      this.recievedPlayCommandAt = new Date();
      if (confirm('Play video?')) {
        // adjust time to achieve sync
        videoEl[0].currentTime += (new Date() - this.recievedPlayCommandAt) / 1000;
        videoEl[0].play().then((msg) => { console.log('Play requested', msg); });
      }
    } else {
      videoEl[0].play().then((msg) => { console.log('Play requested', msg); });
    }
  }
}

export default VideoPlayerControls;
